export const SAVE_PARTY_SUB_PARTY="SAVE_PARTY_SUB_PARTY"
export const POST_PARTY_SUB_PARTY_SUCCESS="POST_PARTY_SUB_PARTY_SUCCESS"


export const GET_PARTY_SUB_PARTY_LIST="GET_PARTY_SUB_PARTY_LIST"
export const GET_PARTY_SUB_PARTY_LIST_SUCCESS="GET_PARTY_SUB_PARTY_LIST_SUCCESS"

export const DELETE_PARTY_SUB_PARTY="DELETE_PARTY_SUB_PARTY"
export const DELETE_PARTY_SUB_PARTY_SUCCESS="DELETE_PARTY_SUB_PARTY_SUCCESS"

export const EDIT_PARTY_SUB_PARTY="EDIT_PARTY_SUB_PARTY"
export const EDIT_PARTY_SUB_PARTY_SUCCESS="EDIT_PARTY_SUB_PARTY_SUCCESS"

export const UPDATE_PARTY_SUB_PARTY="UPDATE_PARTY_SUB_PARTY"
export const UPDATE_PARTY_SUB_PARTY_SUCCESS="UPDATE_PARTY_SUB_PARTY_SUCCESS"

export const GET_PARTY_SUB_PARTY_FOR_PARTY_DROPDOWN="GET_PARTY_SUB_PARTY_FOR_PARTY_DROPDOWN"
export const GET_PARTY_SUB_PARTY_FOR_PARTY_DROPDOWN_SUCCESS="GET_PARTY_SUB_PARTY_FOR_PARTY_DROPDOWN_SUCCESS"

export const DELETE_ID_FOR_MASTER_PAGE="DELETE_ID_FOR_MASTER_PAGE"
export const DELETE_ID_FOR_MASTER_PAGE_SUCCESS="DELETE_ID_FOR_MASTER_PAGE_SUCCESS"

export const PARTY_SUB_PARTY_API_ERROR_ACTION="PARTY_SUB_PARTY_API_ERROR_ACTION"